import { faFilter } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";
import { BlueOutlineButton } from "components/components/BlueOutlineButton/BlueOutlineButton";
import Icon, { SvgIconName } from "components/components/Icon/Icon";
import { IconSize } from "components/components/Icon/IconWrapper";
import featureFlags from "utils/featureFlags";

import { OldStyledFilterButton } from "./style";

interface FilterButtonProps {
  buttonText: string;
  onClick: () => void;
  isActive?: boolean;
  className?: string;
  dataTestId?: string;
}

export const FilterButton: React.FC<FilterButtonProps> = ({
  buttonText,
  onClick,
  isActive = false,
  className,
  dataTestId,
}) =>
  featureFlags.rebrand ? (
    <BlueOutlineButton
      type="button"
      onClick={onClick}
      className={classnames({ active: isActive }, className)}
      dataTestId={dataTestId}
      buttonText={buttonText}
      iconName={SvgIconName.Filter}
      iconSize={IconSize.xSmall}
    />
  ) : (
    <OldStyledFilterButton
      type="button"
      onClick={onClick}
      className={classnames({ active: isActive }, className)}
      data-test-id={dataTestId}
    >
      <span>{buttonText}</span>
      <Icon iconName={faFilter} size={IconSize.xSmall} />
    </OldStyledFilterButton>
  );
